<template>
  <div class="repaymen-detail">
    <BaseHeaderBar
      title="Rincian"
      :showCustomerService="false"
      :showBackButton="true"
    />

    <div class="top-block">
      <p class="p1">
        {{ repaymentDetail.badrnkName }}（{{ repaymentDetail.badrnkAccount }}）
      </p>
      <p class="p2">Jumlah pinjaman sudah ditransfer ke rekening bank ini</p>
      <p class="p2">Nama Pengguna: {{ repaymentDetail.cudrstomerName }}</p>
    </div>
    <div class="detail-list">
      <!-- 借款金额 -->
      <div class="info">
        <p>Nominal Pinjaman</p>
        <p>Rp{{ formatNumberWithCommas(repaymentDetail.lodranAmount) }}</p>
      </div>
      <!-- 贷款日期 -->
      <div class="info">
        <p>Waktu Pinjaman</p>
        <p>{{ repaymentDetail.ardrrivalTime }}</p>
      </div>
      <!-- 还款日期 -->
      <div class="info">
        <p>Waktu Pembayaran</p>
        <p>{{ repaymentDetail.redrpaymentTime }}</p>
      </div>

      <!-- 贷款期限 -->
      <div class="info">
        <p>Tenor Pinjaman</p>
        <p>{{ repaymentDetail.tidrmers }}</p>
      </div>
      <!-- 逾期天数 -->
      <div class="info">
        <p>Jumlah Hari Keterlambatan</p>
        <p>{{ repaymentDetail.ovdrerdueDay }} Hari</p>
      </div>
      <!-- 逾期罚息 -->
      <div class="info">
        <p>Denda Keterlambatan</p>
        <p>
          Rp{{
            formatNumberWithCommas(repaymentDetail.ovdrerdueInterestpenalty)
          }}
        </p>
      </div>
      <!-- 逾期违约金 -->
      <div class="info last">
        <p>Biaya Penundaan Keterlambatan</p>
        <p>
          Rp{{
            formatNumberWithCommas(repaymentDetail.ovdrerdueLiquidateddamages)
          }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'RepaymenDetail',
  data () {
    return {
      repaymentDetail: {}
    }
  },
  created () {
    this.getRepaymentDetail()
  },
  methods: {
    getRepaymentDetail () {
      request.post('homeDRInterface')
        .then(res => {
          this.repaymentDetail = res.bidrllDetails
        })
    }
  }
}
</script>

<style scoped lang="less">
.repaymen-detail {
  min-height: 100vh;
  background-color: @body-bg-color;
}

.top-block {
  margin: 50px 34px;
  margin-top: 10px;
  padding: 30px 15px;
  background: url("~@/assets/img/huankuan_bg.png") no-repeat;
  background-size: 100% 100%;

  p {
    color: #000;
    &:nth-child(n + 2) {
      margin-top: 24px;
    }
  }

  .p1 {
    font-size: 32px;
    font-weight: 600;
    margin-top: 20px;
  }

  .p2 {
    width: 530px;
    font-size: 26px;
  }
}

.detail-list {
  margin: 40px 34px;

  .info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 30px;
    height: 94px;
    margin-bottom: 40px;
    background: #ffffff;
    box-shadow: 1px 8px 0px 0px #000000;
    border-radius: 47px;
    border: 2px solid #000000;
    font-weight: 500;
    font-size: 32px;
    color: #000000;
  }
}
</style>
